/**
 * Header — Dynamic nav rendering and app switcher.
 */

import { getAppIcon } from "./launcher.js";

/**
 * Render the header for home/launcher mode (no app-specific nav).
 */
export function renderHeaderHome(headerNav, headerTitle) {
  headerNav.innerHTML = "";
  headerNav.style.display = "none";
  if (headerTitle) headerTitle.textContent = "Angry Chickz";
}

/**
 * Render the header for an active app with its nav items.
 */
export function renderHeaderApp(headerNav, headerTitle, manifest, currentView, onNavigate) {
  if (headerTitle) headerTitle.textContent = manifest.shortName || manifest.name;

  if (!manifest.nav || manifest.nav.length === 0) {
    headerNav.innerHTML = "";
    headerNav.style.display = "none";
    return;
  }

  headerNav.style.display = "flex";
  headerNav.innerHTML = manifest.nav
    .map(
      (item) =>
        `<a class="nav-link${item.id === currentView ? " active" : ""}" href="#${manifest.id}/${item.id}" data-app-nav="${item.id}">${item.label}</a>`
    )
    .join("");

  // Attach click handlers
  headerNav.querySelectorAll("[data-app-nav]").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const view = link.dataset.appNav;
      // Update active state
      headerNav.querySelectorAll(".nav-link").forEach((l) => l.classList.remove("active"));
      link.classList.add("active");
      onNavigate(view);
    });
  });
}

/**
 * Update the active nav link without re-rendering the whole nav.
 */
export function setActiveNavItem(headerNav, viewId) {
  headerNav.querySelectorAll(".nav-link").forEach((link) => {
    link.classList.toggle("active", link.dataset.appNav === viewId);
  });
}
